export default "__VITE_ASSET__799380be__"